import { PaymentMethodListResponseType } from "@sellar-io/api-v2/types";
import { useState } from "react";
import { Dialog, DialogNavigation } from "../../../../components/modal/Dialog";
import { capitalize } from "../../../../utils/nativeLodash";
import { PaymentMethodDeleteSubmitContent } from "./PaymentMethodDeleteSubmitContent";
import { PaymentMethodDeleteSupplierSelectionContent } from "./PaymentMethodDeleteSupplierSelectionContent";

export type SelectedSuppliersType =
  PaymentMethodListResponseType[number]["Suppliers"];
export type StepType = "supplier-selection" | "submit";
export const PaymentMethodDeleteDialog = ({
  active,
  onDismiss,
  suppliers,
  funding,
  brand,
}: {
  active: boolean;
  onDismiss: () => void;
  brand: string | null;
  funding: string | null;
  suppliers: SelectedSuppliersType;
}) => {
  const [step, setStep] = useState<StepType>("supplier-selection");
  const [selectedPaymentMethodIds, setSelectedPaymentMethodIds] =
    useState<number[]>();
  const cardName = `${capitalize(brand ?? "")} ${capitalize(funding ?? "")}`;
  const onDialogDismiss = () => {
    setSelectedPaymentMethodIds(undefined);
    setStep("supplier-selection");
    onDismiss();
  };

  return (
    <Dialog active={active} onDismiss={onDialogDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={() => onDialogDismiss()}
        title={
          step === "supplier-selection"
            ? cardName
            : "Remove access to payment card"
        }
        description={
          step === "supplier-selection"
            ? "The suppliers you have authorised to use this card for future payments."
            : `Are you sure you want to remove access to ${cardName}`
        }
      />
      {step === "supplier-selection" ? (
        <PaymentMethodDeleteSupplierSelectionContent
          suppliers={suppliers}
          selectedPaymentMethodIds={selectedPaymentMethodIds}
          setSelectedPaymentMethodIds={setSelectedPaymentMethodIds}
          setStep={setStep}
        />
      ) : (
        <PaymentMethodDeleteSubmitContent
          onDismiss={onDialogDismiss}
          selectedPaymentMethodIds={selectedPaymentMethodIds}
        />
      )}
    </Dialog>
  );
};
